
import dayjs from 'dayjs'
import { bus } from '~/assets/js/eventBus'
const emoji = require('emoji')
let optime = 0

export default {
  name: 'EmojiPick',
  data() {
    return {
      emojiMap: emoji.EMOJI_MAP,
      showEmoticon: false,
      isRequest: false
    }
  },
  mounted() {
    document.addEventListener(
      'click',
      () => {
        setTimeout(() => {
          this.showEmoticon = false
        }, 100)
      },
      { passive: true }
    )
    console.log('emoji pick')
  },
  methods: {
    // 表情包点击事件
    selectEmoji(emoji) {
      const that = this
      if (that.isRequest) {
        return false
      }
      that.isRequest = true
      const _time = dayjs().valueOf()
      if (emoji.length > 2) {
        emoji = emoji.substr(0, 2)
      }
      if (!optime || _time - optime > 800) {
        optime = _time
        bus.$emit('getemoji', emoji)
      } else {
        console.log('selectEmoji-重复的', _time)
      }
      that.showEmoticon = false
      that.isRequest = false
    },
    PopEmoji() {
      this.showEmoticon = true
    }
  }
}
